export default __webpack_public_path__ + "static/media/Erlik's Knife of the Afterlife.9a37a2d2.jpg";